import { Button } from '@outdoor-voices/ui';
import PropTypes from 'prop-types';
import { Five } from './Five';
import { ThreeFour } from './ThreeFour';
import { Two } from './Two';
import { Wrapper } from '../Wrapper';
import css from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Category = function Category(_ref) {
  var blocks = _ref.blocks,
      title = _ref.title,
      cta = _ref.cta,
      displayBackground = _ref.displayBackground,
      url = _ref.url;
  var Child = false;
  var numberOfBlocks = blocks.edges.length;

  if (numberOfBlocks < 2) {
    return false;
  }

  switch (numberOfBlocks) {
    case 1:
    case 2:
      Child = Two;
      break;

    case 3:
    case 4:
      Child = ThreeFour;
      break;

    case 5:
    case 6:
      Child = Five;
      break;
  }

  return /*#__PURE__*/_jsx(Wrapper, {
    wrap: displayBackground,
    children: /*#__PURE__*/_jsxs("section", {
      className: css.root,
      children: [title && /*#__PURE__*/_jsx("h4", {
        className: css.title,
        children: title
      }), /*#__PURE__*/_jsx(Child, {
        blocks: blocks
      }), cta && url && /*#__PURE__*/_jsx("div", {
        className: css.cta,
        children: /*#__PURE__*/_jsx(Button, {
          "aria-label": "".concat(cta, " ").concat(cta.indexOf(title) > -1 ? '' : title),
          big: true,
          href: url,
          children: cta
        })
      })]
    })
  });
};
Category.propTypes = {
  blocks: PropTypes.shape({
    edges: PropTypes.arrayOf(PropTypes.shape({}))
  }),
  cta: PropTypes.string,
  displayBackground: PropTypes.bool,
  title: PropTypes.string,
  url: PropTypes.string
};